import type { SerializedStyles } from "@emotion/react";
import type { FC, ReactNode } from "react";

import { Container } from "@aviary/layouts";

import * as styles from "./PageContent.styles";

interface Props {
  children: ReactNode;
  customStyles?: SerializedStyles;
}

const PageContent: FC<Props> = ({ children, customStyles, ...rest }) => {
  const containerStyles = [styles.container, customStyles];

  return (
    <main css={styles.main} id="main-content" role="main" tabIndex={0}>
      <Container css={containerStyles} {...rest}>
        {children}
      </Container>
    </main>
  );
};

export { PageContent };
